import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLinkBox16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLinkBox16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm3 3.5a2.5 2.5 0 0 0 0 5h.75a.5.5 0 0 0 0-1H6a1.5 1.5 0 1 1 0-3h.75a.5.5 0 0 0 0-1zm.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3.5 3a2.5 2.5 0 0 0 0-5h-.75a.5.5 0 0 0 0 1H10a1.5 1.5 0 0 1 0 3h-.75a.5.5 0 0 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLinkBox16);
